import { action } from '@ember/object';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';

export default class InitiativesTableStatusSelectorComponent extends Component {
  @service betaToggle;
  @tracked tippyInstance = null;

  get initiative() {
    return this.args.initiative;
  }

  @action
  handleStatusChange(initiative, e) {
    initiative.status = e;
    initiative.save();
  }

  @action setTippyInstance(e) {
    this.tippyInstance = e;
  }
}
